<template>
  <el-dialog
    class="score"
    title="评分规则"
    :visible.sync="dialogVisible"
    :modal-append-to-body="false"
    :append-to-body="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="900px"
  >
    <div class="content">
      <el-table
        :header-cell-style="{ background: '#DDE4FF', color: '#474859' }"
        :data="tableData"
        class="table_box"
        border
        :span-method="arraySpanMethod"
      >
        <el-table-column
          prop="name"
          label="指标类型"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="subName" label="指标描述" align="center">
        </el-table-column>
        <el-table-column
          prop="info"
          label="具体细则"
          align="center"
          width="160"
        >
        </el-table-column>
        <el-table-column
          prop="regular"
          label="计分规则"
          align="center"
          width="262"
        >
        </el-table-column>
        <el-table-column
          prop="score"
          label="最高分值"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "SafetyScoreRegular",
  components: {},
  props: {
    regularResize: {
      type: Number,
      default: {
        return: 0
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      tableData: [
        {
          name: "安全管理",
          subName: "登录得分",
          info: "登录（app）和网页端",
          regular:
            "每天登陆登录（app）/网页端得分 1 分，可累加，按天统计，每天最高 1 分",
          score: "不限"
        },
        {
          name: "安全管理",
          subName: "账号管理",
          info: "账号信息完善",
          regular: "完善信息得 5 分",
          score: "5"
        },
        {
          name: "安全管理",
          subName: "账号管理",
          info: "修改密码",
          regular: "更新密码信息得 1 分",
          score: "1"
        },
        {
          name: "安全管理",
          subName: "日常巡查",
          info: "日常巡查任务完成",
          regular: "每完成一条巡查任务得 2 分, 可累加",
          score: "不限"
        },
        {
          name: "安全管理",
          subName: "日常巡查",
          info: "值班上报",
          regular: "每上报一条值班记录得 1 分, 可累加",
          score: "不限"
        },
        {
          name: "安全管理",
          subName: "隐患管理",
          info: "隐患上报",
          regular: "每上报一条得 2 分，可累加",
          score: "不限"
        },
        {
          name: "安全管理",
          subName: "隐患管理",
          info: "隐患撤销",
          regular: "每撤销一条得 -2 分，可累加",
          score: "不限"
        },
        {
          name: "安全管理",
          subName: "隐患管理",
          info: "隐患指派",
          regular: "每指派一条得 2 分，可累加",
          score: "不限"
        },
        {
          name: "安全管理",
          subName: "隐患管理",
          info: "隐患转派",
          regular: "每转派一条得 2 分，可累加",
          score: "不限"
        },
        {
          name: "安全管理",
          subName: "隐患管理",
          info: "隐患整改",
          regular: "每整改一条得 2 分，可累加",
          score: "不限"
        },
        {
          name: "安全管理",
          subName: "隐患管理",
          info: "隐患验收",
          regular: "每验收一条得 2 分，可累加",
          score: "不限"
        }
      ]
    };
  },
  created() {},
  mounted() {},
  computed: {},
  watch: {
    regularResize(newVal) {
      if (newVal) {
        this.dialogVisible = true;
      }
    }
  },
  methods: {
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      console.log(row, column, rowIndex, columnIndex);
      if (columnIndex === 0) {
        if (rowIndex == 0) {
          return [11, 1];
        } else {
          return [0, 0];
        }
      } else if (columnIndex === 1) {
        if (rowIndex == 0) {
          return [1, 1];
        } else if (rowIndex == 1) {
          return [2, 1];
        } else if (rowIndex == 3) {
          return [2, 1];
        } else if (rowIndex == 5) {
          return [6, 1];
        } else {
          return [0, 0];
        }
      } else {
        return [1, 1];
      }
    }
  },
  destroyed() {}
};
</script>

<style lang="scss" scoped>
.el-table /deep/ tbody tr:hover > td {
  background-color: #ffffff !important;
}
</style>
